import { render, staticRenderFns } from "./verifyCompany.vue?vue&type=template&id=7c36d8ce&scoped=true&"
import script from "./verifyCompany.vue?vue&type=script&lang=js&"
export * from "./verifyCompany.vue?vue&type=script&lang=js&"
import style0 from "./verifyCompany.vue?vue&type=style&index=0&id=7c36d8ce&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c36d8ce",
  null
  
)

export default component.exports